import {ready} from '../main/utils';
import Vue from '../main/vue';
import router from '../main/vue-routes';
import FeaturedBlogPosts from './featured-blog-posts';
import BlogPosts from './blog-posts';

const loadBlog = () => {
  if (document.querySelector('.blog-content')) {
    new Vue({
      el: '.blog-content',
      comments: true,
      components: {
        FeaturedBlogPosts,
        BlogPosts
      },
      methods: {
        scrollDown: () => {
          const carousel = document.querySelector('#blogCarousel');
          window.scrollTo(
            0,
            carousel.getBoundingClientRect().height
          );
        }
      },
      router
    });
  }
};

ready(() => {
  loadBlog();
});
